import { render, staticRenderFns } from "./Representative.vue?vue&type=template&id=552ab44d&scoped=true&"
import script from "./Representative.vue?vue&type=script&lang=js&"
export * from "./Representative.vue?vue&type=script&lang=js&"
import style0 from "./Representative.vue?vue&type=style&index=0&id=552ab44d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552ab44d",
  null
  
)

export default component.exports